import { useCallback } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { message } from 'antd';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { startVideoCall } from '@vantiva-sa/homesight_humaui/Store/videoCallStore';
import { VIDEO_CALL_EXPAND_EVENT } from '@/constants/videoCall';

/* startVideoCall resets the whole call state, so it must never run during a live call. */
const useStartVideoCall = () => {
  const dispatch = useDispatch();
  const store = useStore();
  const trans = useSelector(translator);
  const isInCall = useSelector((state) => state.videoCall.videoCallModalVisible);

  const startCall = useCallback(
    (payload) => {
      // Confirmation dialogs can retain this callback across call start/end transitions.
      if (store.getState().videoCall.videoCallModalVisible) {
        message.warning(trans('CALL_ALREADY_IN_PROGRESS'));
        window.dispatchEvent(new Event(VIDEO_CALL_EXPAND_EVENT));
        return false;
      }
      dispatch(startVideoCall(payload));
      return true;
    },
    [dispatch, store, trans]
  );

  return { startCall, isInCall };
};

export default useStartVideoCall;
